import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';
import type { InventoryUpdatePayload } from '../types/inventoryEdit.types';
import { inventoryNewService } from '../../new/services/inventoryNew.service';

export const inventoryEditService = {
  // Reuse lookup logic from new service
  getLookups: inventoryNewService.getLookups,
  uploadImage: inventoryNewService.uploadImage,

  async getInventoryItem(id: string, companyId: string) {
    const { data, error } = await supabase
      .from('inventory_items')
      .select('*')
      .eq('id', id)
      .eq('company_id', companyId)
      .single();

    if (error) throw error;
    return data;
  },

  async updateInventoryItem(id: string, payload: InventoryUpdatePayload, userId: string, companyId: string) {
    await permissionEngine.assert(userId, 'inventory.items.update', { companyId });

    const itemPayload = {
      name: payload.name.trim(),
      category_name: payload.category_name,
      unit: payload.unit,
      specification: payload.specification?.trim() || null,
      item_type: payload.item_type,
      minimum_stock: Number(payload.minimum_stock || 0),
      unit_price: Number(payload.unit_price || 0),
      warehouse_id: payload.warehouse_id || null,
      storage_location: payload.storage_location?.trim() || null,
      origin_name: payload.origin_name?.trim() || null,
      manufacturer_code: payload.manufacturer_code?.trim() || null,
      supplier_name: payload.supplier_name || null,
      thumbnail_url: payload.thumbnail_url || null,
      is_stock_tracked: payload.is_stock_tracked,
      note: payload.note?.trim() || null,
      specifications: (payload as any).specifications || null,
      updated_at: new Date().toISOString(),
    };

    let query = supabase
      .from('inventory_items')
      .update(itemPayload)
      .eq('id', id);

    if (companyId) {
      query = query.eq('company_id', companyId);
    }

    const { error } = await query;

    if (error) throw error;
  },
};
